import ru from './ru'
import en from './en'

export default {
  en,
  ru
}
